import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { delay, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExamDataallA, ExamDataallB, mockRiesgoMedioError3, mockRiesgoMedioErrorQues, mockRiesgoMedioSegundoError, mockRiesgoMediosuccess } from 'src/app/interceptors/inquilino/riesgo-medio/riesgo-medio';
import { mockcontractsign404, mockcontractsigningno, mockcontractsigningyes } from './inquilino/firma-contrato/firma-contrato';
import { mockotpresume404, mockResponse } from './inquilino/resume/resume';
import { mockPantallaInquilinoError3, mockResponseQuotePhoneList, mockRiesgoMedio, mockRisgomediodos } from './inquilino/tenant-data/tenant-data';
import { succesinactividad } from './inquilino/inactividad/inactividad';
import { mockotp1404, mockOtppantalla1Error1, mockOtppantalla1Error2, mockOtppantalla1Error3, mockOtppantalla1Error6, mockResponseQuotePhoneListValidateotp } from './inquilino/riesgobajo-otp1/riesgobajo-otp1';
import { mock4004, mockOtppantalla2Error1, mockOtppantalla2Error2, mockotpsuccess } from './inquilino/riesgobajo-opt2/riesgobajo-otp2';

@Injectable()
export class MockInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.endsWith(environment.URL_MULESOFT_ORQUESTADOR_INQUILINO)) {

      if (req.body && req.body.MobilePhone) { // para pantallas de datos inquilino 
        if (req.body.MobilePhone === "3146097775") {
          return of(new HttpResponse({ status: 200, body: mockResponseQuotePhoneList })).pipe(delay(3000));
        } else if (req.body.MobilePhone === "3146097776") {
          return of(new HttpResponse({ status: 200, body: mockRisgomediodos })).pipe(delay(3000));
        } else {
          return of(new HttpResponse({ status: 200, body: mockPantallaInquilinoError3 })).pipe(delay(3000));
        }

      }

      if (req.body && req.body.ExamData) { // para pantallas de riesgo medio
        console.log('entra en el interceptor de inquilino' + JSON.stringify(req.body.ExamData));


        if (req.body.ExamData == ExamDataallA) {
          console.log('ExamDataallA');
          return of(new HttpResponse({ status: 200, body: mockRiesgoMediosuccess })).pipe(delay(3000));
        } else if (req.body.ExamData == ExamDataallB) {
          console.log('ExamDataallB');
          return of(new HttpResponse({ status: 200, body: mockRiesgoMedioErrorQues })).pipe(delay(3000));
        }
        console.log('ExamDataallC');
        return of(new HttpResponse({ status: 200, body: mockRiesgoMedioSegundoError })).pipe(delay(3000));
      }

      if (req.body && req.body.validatePhone) { // pantalla 1 otp riesgo bajo

        if (req.body.listPhones[0].isSelect === true) {
          return of(new HttpResponse({ status: 200, body: mockResponseQuotePhoneListValidateotp })).pipe(delay(3000));
        } else if (req.body.listPhones[1].isSelect === true) {
          return of(new HttpResponse({ status: 200, body: mockOtppantalla1Error2 })).pipe(delay(3000));
        } else if (req.body.listPhones[4].isSelect === true) {
          return of(new HttpResponse({ status: 200, body: mockOtppantalla1Error1 })).pipe(delay(3000));
        }
      }

      if (req.body && req.body.resendOTP) {
        console.log('entra resend');
        return of(new HttpResponse({ status: 200, body: mockotpresume404 })).pipe(delay(3000));

      }

      if (req.body && req.body.validateVerificarOTP) { // riesgo bajo otp pantalla 2

        if (req.body.PinNumber === "111111" || req.body.PinNumber === "111114") {
          return of(new HttpResponse({ status: 200, body: mockotpsuccess })).pipe(delay(3000));
        } else if (req.body.PinNumber === "111112" || req.body.PinNumber === "111113") {
          return of(new HttpResponse({ status: 200, body: mockOtppantalla2Error1 })).pipe(delay(3000));
        } else {
          return of(new HttpResponse({ status: 200, body: mockOtppantalla2Error2 })).pipe(delay(3000));
        }
      }

      if (req.body && req.body.signedContract) { // para firma de contrato 
        if (req.body.signedContract === true) {
          return of(new HttpResponse({ status: 200, body: mockcontractsigningyes })).pipe(delay(3000));
        } else if (req.body.signedContract === false) {
          return of(new HttpResponse({ status: 200, body: mockcontractsigningno })).pipe(delay(3000));
        }
      }

      if (req.body && req.body.screenPercentage) {

        return of(new HttpResponse({ status: 200, body: succesinactividad })).pipe(delay(3000));
      }


      return of(new HttpResponse({ status: 200, body: mockResponse })).pipe(delay(3000));
    }

    // Pasar cualquier solicitud no manejada arriba
    return next.handle(req);
  }
}

// inactividad datos inquilino

const mockPantalladeInactividad = { // request 
  quoteId: "1DM4tXxam7XGkjKRvN8RNrQ%2BnyvGBpe%2BPVCGmVS17fGXzJZR55yb0RLyjBo1dhW6",
  isInactivity: true,
  screenPercentage: "55",
  leadRequeriment: "Inactividad datos inquilino"
};

const mockPantalladeInactividadResponse = { // response
  data: {
    quotesResponse: false,
    leadId: "00Qdq000001hQ9xEAE"
  },
  error: false
};